// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calendar-view .calendar-navigation-bar .mdhui-date-range-navigator\n{\n    padding: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/views/CalendarView/CalendarView.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;AACd","sourcesContent":[".calendar-view .calendar-navigation-bar .mdhui-date-range-navigator\n{\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
